module.exports = __webpack_public_path__ + "static/media/sobre.fbd79d65.jpg";